import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import Button from '@panneau/element-button';

var styles = {};

var _excluded = ["name", "label", "value", "href", "theme", "activeTheme", "disableOutline", "onChange", "className"];
var propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  href: PropTypes.string,
  theme: PropTypes.string,
  activeTheme: PropTypes.string,
  disableOutline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
var defaultProps = {
  label: null,
  name: 'button',
  value: false,
  href: null,
  theme: 'primary',
  activeTheme: 'primary',
  disableOutline: false,
  className: null
};
var ButtonFilter = function ButtonFilter(_ref) {
  var name = _ref.name,
    label = _ref.label,
    value = _ref.value,
    href = _ref.href,
    theme = _ref.theme,
    activeTheme = _ref.activeTheme,
    disableOutline = _ref.disableOutline,
    onChange = _ref.onChange,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isActive = useMemo(function () {
    return value !== null && (value === true || value === 'true' || value === 1 || value === '1');
  }, [value]);
  var onClick = useCallback(function () {
    if (href === null) {
      if (isActive) {
        onChange(null);
      } else {
        onChange(true);
      }
    }
  }, [isActive, href, name, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    href: href,
    label: label,
    name: name,
    onClick: onClick,
    outline: (!isActive || href !== null) && !disableOutline,
    theme: isActive ? activeTheme : theme
  }, props)));
};
ButtonFilter.propTypes = propTypes;
ButtonFilter.defaultProps = defaultProps;

export { ButtonFilter as default };
